"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeResult = exports.updateResult = exports.addResult = exports.removeCondition = exports.updateCondition = exports.addCondition = exports.updateRule = exports.deleteDataSheet = exports.addDataSheet = exports.addRule = void 0;

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var createRule = function createRule(name) {
  return {
    name: name,
    description: '',
    conditions: [],
    results: []
  };
};

var createDataSheet = function createDataSheet(name) {
  return {
    name: name,
    rows: []
  };
};

var createCondition = function createCondition(condition, option) {
  return {
    attribute: '',
    operator: undefined
  };
};

var addRule = function addRule() {
  var rules = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var name = arguments.length > 1 ? arguments[1] : undefined;
  return [createRule(name)].concat(_toConsumableArray((0, _cloneDeep["default"])(rules)));
};

exports.addRule = addRule;

var addDataSheet = function addDataSheet() {
  var dataSheets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var name = arguments.length > 1 ? arguments[1] : undefined;
  return [createDataSheet(name)].concat(_toConsumableArray((0, _cloneDeep["default"])(dataSheets)));
};

exports.addDataSheet = addDataSheet;

var deleteDataSheet = function deleteDataSheet(dataSheets, index) {
  var newDataSheets = (0, _cloneDeep["default"])(dataSheets);
  newDataSheets.splice(index, 1);
  return newDataSheets;
};

exports.deleteDataSheet = deleteDataSheet;

var updateRule = function updateRule(rules, name, rule) {
  var newRules = (0, _cloneDeep["default"])(rules);
  return rules && newRules.map(function (ruleValue) {
    return ruleValue.name === name ? rule : ruleValue;
  }).filter(function (ruleValue) {
    return ruleValue;
  });
};

exports.updateRule = updateRule;

var addCondition = function addCondition(rule) {
  return _objectSpread(_objectSpread({}, (0, _cloneDeep["default"])(rule)), {}, {
    conditions: rule.conditions.concat([createCondition()])
  });
};

exports.addCondition = addCondition;

var updateCondition = function updateCondition(rule, originalCondition, condition) {
  return _objectSpread(_objectSpread({}, rule), {}, {
    conditions: rule.conditions.map(function (value) {
      return value === originalCondition ? condition : value;
    })
  });
};

exports.updateCondition = updateCondition;

var removeCondition = function removeCondition(rule, originalCondition, condition) {
  return _objectSpread(_objectSpread({}, rule), {}, {
    conditions: rule.conditions.filter(function (value) {
      return value !== originalCondition;
    })
  });
};

exports.removeCondition = removeCondition;

var addResult = function addResult(rule) {
  return _objectSpread(_objectSpread({}, (0, _cloneDeep["default"])(rule)), {}, {
    results: rule.results.concat([createCondition()])
  });
};

exports.addResult = addResult;

var updateResult = function updateResult(rule, originalResult, result) {
  return _objectSpread(_objectSpread({}, rule), {}, {
    results: rule.results.map(function (value) {
      return value === originalResult ? result : value;
    })
  });
};

exports.updateResult = updateResult;

var removeResult = function removeResult(rule, originalResult) {
  return _objectSpread(_objectSpread({}, rule), {}, {
    results: rule.results.filter(function (value) {
      return value !== originalResult;
    })
  });
};

exports.removeResult = removeResult;